<template>
	<div>
		<a-modal :title="$t('studentsCom.resolved')" :width="650" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null"
			:pagination="false">
			<div class="ftr-1 cl-black">
				<div class="cl-info">
					{{$t('studentsCom.selectSolutionTip')}}
				</div>
				<div class="mt-4">
					*{{$t('studentsCom.selectSolution')}}
				</div>
				<select class="form-select mt-3" aria-label="Default select example">
				    <option selected>{{$t('studentsCom.selectPlaceholder')}}</option>
				    <option value="1">中文（繁体）</option>
				    <option value="2">中文（简体）</option>
				    <option value="3">韩语</option>
				    <option value="4">日语</option>
				</select>
				<div class="mt-4">
					*{{$t('studentsCom.fillRefundAmount')}}
				</div>
				<select class="form-select mt-2" aria-label="Default select example">
				    <option selected>{{$t('studentsCom.selectPlaceholder')}}</option>
				    <option value="1">中文（繁体）</option>
				    <option value="2">中文（简体）</option>
				    <option value="3">韩语</option>
				    <option value="4">日语</option>
				</select>
				<div class="cl-info mt-4">
					{{$t('studentsCom.feeDeductionTip')}}
				</div>
				
				<div class="mt-4 d-flex justify-content-center">
					<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()">{{$t('common.cancel')}} </button>
					<button type="button" class="btn btn-theme ml16 px-4">{{$t('common.confirm')}} </button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				codeLoading: false,
				account: '',
				rate:3
			}
		},
		created() {
	
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
	
		}
	}
</script>

<style>
</style>